import * as React from 'react';
import styled from '@emotion/styled';
import moment, { Moment } from 'moment';
import { IconNames } from '@blueprintjs/icons';
import $ from 'jquery';
import { Button, Tooltip, Intent, Dialog, Classes } from '@blueprintjs/core';
import {
  blackpoint,
  blackpointEconomic,
  blackpointHealthy,
  blackpointSpecial,
  dutyDay,
  dutyDayNight,
  dutyNight,
  dutyOff,
} from '../../../assets';
import { Instance } from 'mobx-state-tree';
import { Pharmacy, PharmacyDetails, SystemStatus, User } from '../../../store/models';
import NotificationToast from '../NotificationToast';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { TLCode } from '../../../common/enums';
import { Position } from '@blueprintjs/core/lib/esm/common/position';
import { ContextMenu2ContentProps } from '@blueprintjs/popover2';
import { simulateClickOn } from '../../../common/clickSimulation';
import { getS1, getS2, getSemester, Semester } from '../../../common/utils';
import { Group } from '../../../store/models/Group';
import { DutyToSendToAnotherCalendar } from '../../../store/interfaces/DutyToSend';
import _ from 'lodash';
import { WarningDialog } from '../dialog/WarningDialog';
import { NavigateContainer } from '../styledComponents/StyledComponents';
import { CalendarContextToolbox, CalendarContextToolboxProps } from './toolbox/CalendarContextToolbox';
import { CalendarCounters } from './toolbox/CalendarCounters';
import { ToolboxAndLegend } from './toolbox/ToolboxAndLegend';
import { PharmacyPreferenceNoDutyDayForCalendar } from './pharmacy/PharmacyDetailsForCalendar';
import { IsWeekend } from '../../../common/date/dateUtils';
import { OneLinePharmacyCalendarDatePicker } from './datePicker/OneLinePharmacyCalendarDatePicker';
import { TwoLinesPharmacyCalendarDatePicker } from './datePicker/TwoLinesPharmacyCalendarDatePicker';
import { LazyPharmacySelectionForCalendar } from './pharmacy/LazyPharmacySelectionForCalendar';
import { ConfirmationDialog } from '../dialog/ConfirmationDialog';
import { CheckBox, SpeedDialAction } from 'devextreme-react';
import { SemesterDutyCountersProps } from './toolbox/SemesterDutyCounters';
import { flashingButton } from '../styledComponents/StyledClasses';
import { number } from 'mobx-state-tree/dist/internal';
import { SharedDutiesGroupInformation } from './pharmacy/SharedDutiesGroupInformation';
import { CalendarPerfMonitor } from './CalendarPerfMonitor';

export const dateFormatMultiCalendar = 'YYYY-MM-DD';
export const dateFormatMultiCalendar2 = 'DDDD DD-MM-YYYY';

export enum MultiCalendarSelectionType {
  dutyOffRequest = 'dutyoffrequest',
  blackpoint = 'blackpoint',
  blackpointHealthy = 'blackpointHealthy',
  blackpointEconomic = 'blackpointEconomic',
  blackpointSpecial = 'blackpointSpecial',
  candidates = 'candidates',
  delete = 'delete',
  dayDuty = 'dayDuty',
  dayNightDuty = 'dayNightDuty',
  nightDuty = 'nightDuty',
  inactive = 'inactive',
}

export interface MultiCalendarProps extends WithTranslateProps {
  bankHolidayDates: string[];
  blackPoints: string[];
  blackPointsEconomic: string[];
  blackPointsHealth: string[];
  blackPointsSpecial: string[];
  dayDuties: string[];
  dayNightDuties: string[];
  nightDuties: string[];
  saturdayDuties: string[];
  sundayDuties: string[];
  BHDuties: string[];
  newBlackPoints: string[];
  newBlackPointsEconomic: string[];
  newBlackPointsHealth: string[];
  newBlackPointsSpecial: string[];
  newDayDuties: string[];
  newDayNightDuties: string[];
  newNightDuties: string[];
  deletedDutyOffRequests: string[];
  deletedBlackPoints: string[];
  deletedBlackPointsEconomic: string[];
  deletedBlackPointsHealth: string[];
  deletedBlackPointsSpecial: string[];
  deletedDayDuties: string[];
  deletedDayNightDuties: string[];
  deletedNightDuties: string[];
  deletedExemptions: string[];
  dutyOffRequestDates: string[];
  navigateMonthCount: number;
  onDatesChange: (data: any) => void;
  systemStatus: Array<Instance<typeof SystemStatus>>;
  blackPointHolidayMax?: number;
  blackPointEconomicMax?: number;
  annualFreeBankHolidayMax?: number;
  annualFreeWeekendMax?: number;
  isSecretariat?: boolean;
  fly?: number;
  sly?: number;
  onCalendarMove: (fly: number, sly: number) => void;
  rowCount?: number;
  hideLegend?: boolean;
  synchronizedScrolling?: boolean;
  onTypeChange?: (type: MultiCalendarSelectionType | undefined) => void;
  selectedType?: MultiCalendarSelectionType | undefined;
  separateToolbox?: boolean;
  pharmacyDetails?: Instance<typeof PharmacyDetails>;
  pharmacyId?: number;
  pharmacyList?: any;
  onPharmacyChange?: (selectedOption: any) => void;
  onOtherPharmacyChange?: (otherPharmacyId: Instance<typeof number> | undefined) => void;
  groupList: Array<Instance<typeof Group>>;
  onDutyToSendToAnotherPharmacy?: (date: Date, dutyType: 'NIGHT' | 'DAY' | 'DAYNIGHT', pharmacyId: number) => void;
  otherPharmacyBusyDates?: Array<Date>;
  dutySentToAnotherPharmacy?: DutyToSendToAnotherCalendar;
  inMultiCalendar?: boolean;
  onDutySentConsumed?: () => void;
  pharmacyUser?: Instance<typeof User>;
  groupIdToLimitTo?: number;
  showCandidatesButton?: boolean;
  canCandidatesDialogBeReopened: boolean;
  openCandidatesDialog: (date: string) => void;
  openExchangeHistoryPopup?: () => void;
  getAvailablePharmacyList?: (date, apbNumber, showAlsoCurrentPharmacy) => any[];
  sharedDutiesGroupPharmacies?: Array<Instance<typeof Pharmacy>>;
  navigateTo?: (url: string) => void;
  exchangeDutyDates?: string[];
}

export interface MultiCalendarState {
  isOpen: boolean;
  selectedDate?: string;
  showSelectedCandidatesDate?: boolean;
  firstMonthFirstLine: number;
  firstMonthSecondLine: number;
  currentS1: Semester;
  currentS2: Semester;
  yearFirstLine: number;
  yearSecondLine: number;
  selectedType?: MultiCalendarSelectionType;
  shiftPressed: boolean;
  isContextualMenuDisabled: boolean;
  nextActionAfterContextMenu: (() => void) | undefined;
  isWarningDialogOpen: boolean;
  isConfirmationDialogOpen: boolean;
  dateChangedToBeConfirm?: string;
  selectionTypeToBeConfirm?: MultiCalendarSelectionType;
  selectionTypeToBeDeleted?: MultiCalendarSelectionType;
  limitSelectionToGroupOfFirstPickedPharmacy?: boolean;
  showCandidates: boolean;
  showCandidatesButton: boolean;
  canBeReopen: boolean;
  selectedPharmacy: Instance<typeof PharmacyDetails> | undefined;
}

class MultiCalendar extends React.Component<MultiCalendarProps, MultiCalendarState> {
  /** Timestamp captured at the start of each render() call — used by perf reporting in lifecycle hooks. */
  private _perfRenderStart: number = 0;

  // Single-entry cache for formatDay: DayPicker passes the same Date object to every modifier for a given
  // day, so one reference-equality check eliminates ~19 out of every 20 Moment constructions.
  private _lastFormattedDay: Date | null = null;
  private _lastFormattedDayStr: string = '';

  /** Format a Date as 'YYYY-MM-DD' without Moment, with a single-entry reference cache. */
  private formatDay = (day: Date): string => {
    if (day === this._lastFormattedDay) return this._lastFormattedDayStr;
    const y = day.getFullYear();
    const m = String(day.getMonth() + 1).padStart(2, '0');
    const d = String(day.getDate()).padStart(2, '0');
    this._lastFormattedDayStr = `${y}-${m}-${d}`;
    this._lastFormattedDay = day;
    return this._lastFormattedDayStr;
  };

  // Sets rebuilt from props at the start of each render — O(N) once instead of O(N) per day-cell per modifier.
  private _bankHolidayDatesSet = new Set<string>();
  private _dayDutiesSet = new Set<string>();
  private _nightDutiesSet = new Set<string>();
  private _dayNightDutiesSet = new Set<string>();
  private _blackPointsSet = new Set<string>();
  private _blackPointsEconomicSet = new Set<string>();
  private _blackPointsHealthSet = new Set<string>();
  private _blackPointsSpecialSet = new Set<string>();
  private _deletedDayDutiesSet = new Set<string>();
  private _deletedNightDutiesSet = new Set<string>();
  private _deletedDayNightDutiesSet = new Set<string>();
  private _deletedBlackPointsSet = new Set<string>();
  private _deletedBlackPointsEconomicSet = new Set<string>();
  private _deletedBlackPointsHealthSet = new Set<string>();
  private _deletedBlackPointsSpecialSet = new Set<string>();
  private _deletedExemptionsSet = new Set<string>();
  private _dutyOffRequestDatesSet = new Set<string>();
  private _newBlackPointsSet = new Set<string>();
  private _newBlackPointsEconomicSet = new Set<string>();
  private _newBlackPointsHealthSet = new Set<string>();
  private _newBlackPointsSpecialSet = new Set<string>();
  private _newDayDutiesSet = new Set<string>();
  private _newDayNightDutiesSet = new Set<string>();
  private _newNightDutiesSet = new Set<string>();
  // Union of all new/deleted arrays — drives the `changed` modifier in O(1).
  private _changedDatesSet = new Set<string>();
  private _exchangeDutiesSet = new Set<string>();

  state = {
    firstMonthFirstLine: 0,
    firstMonthSecondLine: 6,
    isOpen: false,
    shiftPressed: false,
    yearFirstLine: this.props.fly ? this.props.fly : moment().year(),
    yearSecondLine: this.props.sly ? this.props.sly : moment().year(),
    selectedType: this.props.selectedType ? this.props.selectedType : undefined,
    selectedDate: undefined,
    showSelectedCandidatesDate: false,
    isContextualMenuDisabled: false,
    nextActionAfterContextMenu: undefined,
    isWarningDialogOpen: false,
    isConfirmationDialogOpen: false,
    dateChangedToBeConfirm: undefined,
    selectionTypeToBeConfirm: undefined,
    selectionTypeToBeDeleted: undefined,
    limitSelectionToGroupOfFirstPickedPharmacy: true,
    currentS1: getS1(this.props.fly ? this.props.fly : moment().year()),
    currentS2: getS2(this.props.fly ? this.props.fly : moment().year()),
    showCandidates: false,
    showCandidatesButton: false,
    canBeReopen: false,
    selectedPharmacy: undefined,
  } as MultiCalendarState;

  areDutiesToSendToAnotherCalendarEquals = (
    duty1: DutyToSendToAnotherCalendar | undefined,
    duty2: DutyToSendToAnotherCalendar | undefined,
  ): boolean => {
    if ((duty1 === undefined && duty2 !== undefined) || (duty1 !== undefined && duty2 === undefined)) return false;
    return _.isEqual(duty1, duty2);
  };

  getDutyTypeFromString = (DutyType: string): MultiCalendarSelectionType => {
    switch (DutyType.toUpperCase()) {
      case 'DAY':
        return MultiCalendarSelectionType.dayDuty;
      case 'DAYNIGHT':
        return MultiCalendarSelectionType.dayNightDuty;
    }
    return MultiCalendarSelectionType.delete;
  };

  componentDidUpdate(prevProps: MultiCalendarProps) {
    // ── Perf monitoring ──────────────────────────────────────────────────────
    CalendarPerfMonitor.accumulate('[MC] render→update cycle', performance.now() - this._perfRenderStart);
    // report() lives in PharmacyDutiesCalendar.componentDidUpdate — it fires after all children.
    // ─────────────────────────────────────────────────────────────────────────
    // Guard against the redundant setState that happens when navigate() already set the correct year
    // in local state and the new fly/sly prop then arrives back down from MultiCalendarsForComparison.
    if (prevProps.fly !== this.props.fly && Number(this.props.fly) !== this.state.yearFirstLine) {
      this.setState({
        yearFirstLine: Number(this.props.fly),
        currentS1: getS1(this.props.fly ? this.props.fly : moment().year()),
        currentS2: getS2(this.props.fly ? this.props.fly : moment().year()),
      });
    }
    if (prevProps.sly !== this.props.sly && Number(this.props.sly) !== this.state.yearSecondLine) {
      this.setState({ yearSecondLine: Number(this.props.sly) });
    }
    if (prevProps.selectedType !== this.props.selectedType) {
      this.setState({ selectedType: this.props.selectedType, selectedDate: undefined });
    }

    if (this.state.nextActionAfterContextMenu !== undefined || this.state.isContextualMenuDisabled) {
      const action = this.state.nextActionAfterContextMenu;
      this.setState({ nextActionAfterContextMenu: undefined, isContextualMenuDisabled: false }, () => {
        if (action !== undefined) action();
      });
    }

    if (prevProps.canCandidatesDialogBeReopened !== this.props.canCandidatesDialogBeReopened) {
      this.setState({ showSelectedCandidatesDate: this.props.canCandidatesDialogBeReopened });
    }

    if (
      this.props.dutySentToAnotherPharmacy !== undefined &&
      !this.areDutiesToSendToAnotherCalendarEquals(
        prevProps.dutySentToAnotherPharmacy,
        this.props.dutySentToAnotherPharmacy,
      ) &&
      this.props.dutySentToAnotherPharmacy.FromPharmacyId !== this.props.pharmacyId
    ) {
      const dutyType = this.getDutyTypeFromString(this.props.dutySentToAnotherPharmacy.DutyType);
      this.onDateSelect(this.props.dutySentToAnotherPharmacy.Date, dutyType);
      if (this.props.onDutySentConsumed !== undefined) this.props.onDutySentConsumed();
    }
  }

  async componentDidMount() {
    // Scroll the scrolling calendar to last saved position.
    if (this.props.synchronizedScrolling) {
      $('.scrollingCalendar').each(function(index, element: any) {
        const $element: any = $(element);
        $element.scrollTop(sessionStorage.getItem('scrollingCalendarScrollPositionTop'));
        $element.scrollLeft(sessionStorage.getItem('scrollingCalendarScrollPositionLeft'));
      });
    }
    // ── Perf monitoring ──────────────────────────────────────────────────────
    CalendarPerfMonitor.accumulate('[MC] render→mount cycle', performance.now() - this._perfRenderStart);
    // report() lives in PharmacyDutiesCalendar.componentDidMount — it fires after all children.
    // ─────────────────────────────────────────────────────────────────────────
  }

  componentWillUnmount() {
    this.setState({ isContextualMenuDisabled: true });
  }

  handleKeyPress = (e) => {
    if (e.key === 'Shift' && !this.state.shiftPressed) {
      this.setState({ shiftPressed: true });
    }
  };

  handleKeyUnPress = (e) => {
    if (e.key === 'Shift' && this.state.shiftPressed) {
      this.setState({ shiftPressed: false });
    }
  };

  onTypeChange = (type: MultiCalendarSelectionType | undefined) => {
    if (this.state.selectedType !== type) {
      this.setState({ selectedType: type, selectedDate: undefined });
      if (this.props.onTypeChange) this.props.onTypeChange(type);
    }
  };

  checkExistingDate = (date: string) => {
    const {
      blackPoints,
      blackPointsHealth,
      blackPointsEconomic,
      blackPointsSpecial,
      dayNightDuties,
      dayDuties,
      nightDuties,
      dutyOffRequestDates,
      newBlackPoints,
      newBlackPointsEconomic,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newNightDuties,
      newDayNightDuties,
      deletedDutyOffRequests,
      deletedBlackPoints,
      deletedBlackPointsHealth,
      deletedBlackPointsEconomic,
      deletedBlackPointsSpecial,
      deletedDayDuties,
      deletedDayNightDuties,
      deletedNightDuties,
    } = this.props;
    const arrays = [
      newBlackPoints,
      newBlackPointsEconomic,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newDayNightDuties,
      newNightDuties,
    ];
    let found = false;
    arrays.forEach((array) => {
      if (array.includes(date)) {
        found = true;
      }
    });
    if (dutyOffRequestDates.includes(date) && !deletedDutyOffRequests.includes(date)) found = true;
    if (blackPoints.includes(date) && !deletedBlackPoints.includes(date)) found = true;
    if (blackPointsEconomic.includes(date) && !deletedBlackPointsEconomic.includes(date)) found = true;
    if (blackPointsHealth.includes(date) && !deletedBlackPointsHealth.includes(date)) found = true;
    if (blackPointsSpecial.includes(date) && !deletedBlackPointsSpecial.includes(date)) found = true;
    if (dayDuties.includes(date) && !deletedDayDuties.includes(date)) found = true;
    if (dayNightDuties.includes(date) && !deletedDayNightDuties.includes(date)) found = true;
    if (nightDuties.includes(date) && !deletedNightDuties.includes(date)) found = true;

    return found;
  };

  hasDutyNextYear = () => {
    const dateMin = new Date(this.state.yearSecondLine + 1, 0, 1);
    const dateMax = new Date(this.state.yearSecondLine + 1, 0, 7);

    const dayNightDutyDates = this.props.dayNightDuties.map((dt) => new Date(dt));
    const res2 = dayNightDutyDates.filter((dt) => {
      return dt >= dateMin && dt <= dateMax;
    });
    if (res2 != null && res2.length > 0) return true;

    const dayDutyDates = this.props.dayDuties.map((dt) => new Date(dt));
    const res1 = dayDutyDates.filter((dt) => {
      return dt >= dateMin && dt <= dateMax;
    });
    if (res1 != null && res1.length > 0) return true;

    return false;
  };

  deleteDate = (date: string) => {
    const {
      dutyOffRequestDates,
      blackPoints,
      blackPointsHealth,
      blackPointsEconomic,
      blackPointsSpecial,
      dayDuties,
      dayNightDuties,
      nightDuties,
      deletedDutyOffRequests,
      deletedBlackPoints,
      deletedBlackPointsEconomic,
      deletedBlackPointsHealth,
      deletedBlackPointsSpecial,
      deletedDayDuties,
      deletedNightDuties,
      deletedDayNightDuties,
    } = this.props;
    let {
      newBlackPoints,
      newBlackPointsEconomic,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newDayNightDuties,
      newNightDuties,
    } = this.props;
    if (newBlackPoints.includes(date)) {
      newBlackPoints = newBlackPoints.filter((e) => e !== date);
    }
    if (newBlackPointsEconomic.includes(date)) {
      newBlackPointsEconomic = newBlackPointsEconomic.filter((e) => e !== date);
    }
    if (newBlackPointsHealth.includes(date)) {
      newBlackPointsHealth = newBlackPointsHealth.filter((e) => e !== date);
    }
    if (newBlackPointsSpecial.includes(date)) {
      newBlackPointsSpecial = newBlackPointsSpecial.filter((e) => e !== date);
    }
    if (newDayDuties.includes(date)) {
      newDayDuties = newDayDuties.filter((e) => e !== date);
    }
    if (newDayNightDuties.includes(date)) {
      newDayNightDuties = newDayNightDuties.filter((e) => e !== date);
    }
    if (newNightDuties.includes(date)) {
      newNightDuties = newNightDuties.filter((e) => e !== date);
    }
    if (dutyOffRequestDates.includes(date)) {
      deletedDutyOffRequests.push(date);
    }
    if (blackPoints.includes(date)) {
      deletedBlackPoints.push(date);
    }
    if (blackPointsHealth.includes(date)) {
      deletedBlackPointsHealth.push(date);
    }
    if (blackPointsEconomic.includes(date)) {
      deletedBlackPointsEconomic.push(date);
    }
    if (blackPointsSpecial.includes(date)) {
      deletedBlackPointsSpecial.push(date);
    }
    if (dayDuties.includes(date)) {
      deletedDayDuties.push(date);
    }
    if (dayNightDuties.includes(date)) {
      deletedDayNightDuties.push(date);
    }
    if (nightDuties.includes(date)) {
      deletedNightDuties.push(date);
    }

    this.props.onDatesChange({
      newBlackPoints,
      newBlackPointsEconomic,
      newBlackPointsHealth,
      newBlackPointsSpecial,
      newDayDuties,
      newDayNightDuties,
      newNightDuties,
      deletedDutyOffRequests,
      deletedBlackPoints,
      deletedBlackPointsEconomic,
      deletedBlackPointsHealth,
      deletedBlackPointsSpecial,
      deletedDayDuties,
      deletedDayNightDuties,
      deletedNightDuties,
    });
  };

  findNextAcceptableBlackpoint = () => {
    const date = this.props.systemStatus.find((elem) => elem.subSystem === 'NextAcceptableBlackpoint');
    if (date) {
      return moment(date.status, 'DD/MM/YYYY');
    } else {
      return moment('01/01/2000', 'DD/MM/YYYY');
    }
  };

  isAcceptableBlackpointDate = (date: Date, first: Moment) => {
    const res = !moment(date).isBefore(first);
    return res;
  };

  getDutyOffRequestsForYearShowed = (arrayNewDutyOffRequest) => {
    const { firstMonthFirstLine, firstMonthSecondLine, yearFirstLine, yearSecondLine } = this.state;
    const { dutyOffRequestDates, deletedDutyOffRequests } = this.props;
    const dateBegin = moment(new Date(yearFirstLine, firstMonthFirstLine, 1));
    const dateEnd = moment(
      new Date(yearSecondLine, firstMonthSecondLine === 6 ? 11 : 5, firstMonthSecondLine === 6 ? 31 : 30),
    ).endOf('day');
    const dutyOff = dutyOffRequestDates
      //.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem)))
      .filter((elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)))
      .concat(
        //arrayNewDutyOffRequest.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem))),
        arrayNewDutyOffRequest.filter(
          (elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)),
        ),
      )
      .concat(
        //deletedDutyOffRequests.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem))),
        deletedDutyOffRequests.filter(
          (elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)),
        ),
      );

    return dutyOff;
  };

  getBlackPointForYearShowed = (arrayNewBlackPoint) => {
    const { firstMonthFirstLine, firstMonthSecondLine, yearFirstLine, yearSecondLine } = this.state;
    const { blackPoints, deletedBlackPoints } = this.props;
    const dateBegin = moment(new Date(yearFirstLine, firstMonthFirstLine, 1));
    const dateEnd = moment(
      new Date(yearSecondLine, firstMonthSecondLine === 6 ? 11 : 5, firstMonthSecondLine === 6 ? 31 : 30),
    ).endOf('day');
    const blackPointHoliday = blackPoints
      //.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem)))
      .filter((elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)))
      //.concat(arrayNewBlackPoint.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem))))
      .concat(
        arrayNewBlackPoint.filter((elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem))),
      )
      //.concat(deletedBlackPoints.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem))));
      .concat(
        deletedBlackPoints.filter((elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem))),
      );

    return blackPointHoliday;
  };

  getEconomicBlackPointForYearShowed = (arrayNewBlackPointEconomic) => {
    const { firstMonthFirstLine, firstMonthSecondLine, yearFirstLine, yearSecondLine } = this.state;
    const { blackPointsEconomic, deletedBlackPointsEconomic } = this.props;
    const dateBegin = moment(new Date(yearFirstLine, firstMonthFirstLine, 1));
    const dateEnd = moment(
      new Date(yearSecondLine, firstMonthSecondLine === 6 ? 11 : 5, firstMonthSecondLine === 6 ? 31 : 30),
    ).endOf('day');
    const blackPointEconomic = blackPointsEconomic
      //.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem)))
      .filter((elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)))
      .concat(
        //arrayNewBlackPointEconomic.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem))),
        arrayNewBlackPointEconomic.filter(
          (elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)),
        ),
      )
      .concat(
        //deletedBlackPointsEconomic.filter((elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem))),
        deletedBlackPointsEconomic.filter(
          (elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)),
        ),
      );

    return blackPointEconomic;
  };

  getBankHolidayForYearShowed = () => {
    const { firstMonthFirstLine, firstMonthSecondLine, yearFirstLine, yearSecondLine } = this.state;
    const { bankHolidayDates } = this.props;
    const dateBegin = moment(new Date(yearFirstLine, firstMonthFirstLine, 1));
    const dateEnd = moment(
      new Date(yearSecondLine, firstMonthSecondLine === 6 ? 11 : 5, firstMonthSecondLine === 6 ? 31 : 30),
    ).endOf('day');
    const bankHolidays = bankHolidayDates.filter(
      //(elem) => dateBegin.isBefore(moment(elem)) && dateEnd.isAfter(moment(elem)),
      (elem) => dateBegin.isSameOrBefore(moment(elem)) && dateEnd.isAfter(moment(elem)),
    );

    return bankHolidays;
  };

  getBlackPointHolidayCount = (arrayNewBlackPoint) => {
    return this.getBlackPointForYearShowed(arrayNewBlackPoint).length;
  };

  getBlackPointEconomicCount = (arrayNewEconomicBlackPoint) => {
    return this.getEconomicBlackPointForYearShowed(arrayNewEconomicBlackPoint).length;
  };

  getBlackPointHolidayCountOnBankHoliday = (arrayNewBlackPoint) => {
    const blackPointHoliday = this.getBlackPointForYearShowed(arrayNewBlackPoint);
    const bankHolidays = this.getBankHolidayForYearShowed();
    return blackPointHoliday.filter((elem) => bankHolidays.includes(elem)).length;
  };

  getBlackPointHolidayCountOnWeekends = (arrayNewBlackPoint) => {
    const blackPointHolidays = this.getBlackPointForYearShowed(arrayNewBlackPoint);
    let cnt = 0;
    blackPointHolidays.forEach((holiday) => {
      if (IsWeekend(holiday) && !this.IsBankHoliday(holiday)) {
        cnt += 1;
      }
    });
    return cnt;
  };

  IsBankHoliday = (date) => {
    const bankHolidays = this.getBankHolidayForYearShowed();
    return bankHolidays.includes(date);
  };

  checkCanEdit = (date: Date, arrayNewBlackPoint, arrayNewEconomicBlackPoint) => {
    if (date == null) return false;
    const year = date.getFullYear();
    const first = this.findNextAcceptableBlackpoint();
    const { blackPointHolidayMax, blackPointEconomicMax, annualFreeBankHolidayMax, annualFreeWeekendMax } = this.props;

    let canEdit = true;
    if (!this.isAcceptableBlackpointDate(date, first) && !this.props.isSecretariat!) {
      canEdit = false;
      NotificationToast.showError(this.props.translate(TLCode.MULTI_CALENDAR_ErrorMsgEncodingNotOpenForThisDate));
    } else if (
      this.state.selectedType === MultiCalendarSelectionType.blackpoint &&
      blackPointHolidayMax != null &&
      annualFreeBankHolidayMax != null &&
      annualFreeWeekendMax != null
    ) {
      const countBlackPointHoliday = this.getBlackPointHolidayCount(arrayNewBlackPoint);
      if (countBlackPointHoliday >= blackPointHolidayMax) {
        canEdit = false;
        NotificationToast.showError(this.props.translate(TLCode.MULTI_CALENDAR_ErrorMsgTooManyBlackPoints));
      }
      const countBlackPointHolidayOnBankHoliday = this.getBlackPointHolidayCountOnBankHoliday(arrayNewBlackPoint);
      if (
        this.props.bankHolidayDates.includes(moment(date).format(dateFormatMultiCalendar)) &&
        countBlackPointHolidayOnBankHoliday >= annualFreeBankHolidayMax
      ) {
        canEdit = false;
        NotificationToast.showError(
          this.props.translate(TLCode.MULTI_CALENDAR_ErrorMsgTooManyBlackPointsOnBankHolidays),
        );
      }
      const countBlackPointHolidayOnWeekends = this.getBlackPointHolidayCountOnWeekends(arrayNewBlackPoint);
      if (IsWeekend(date) && countBlackPointHolidayOnWeekends >= annualFreeWeekendMax) {
        canEdit = false;
        NotificationToast.showError(this.props.translate(TLCode.MULTI_CALENDAR_ErrorMsgTooManyBlackPointsOnWeekends));
      }
    } else if (
      this.state.selectedType === MultiCalendarSelectionType.blackpointEconomic &&
      blackPointEconomicMax != null
    ) {
      const countBlackPointEconomic = this.getBlackPointEconomicCount(arrayNewEconomicBlackPoint);
      // le secrétariat peut dépasser le quota mais pas la pharmacie
      if (!this.props.isSecretariat && countBlackPointEconomic >= blackPointEconomicMax) {
        canEdit = false;
        NotificationToast.showError(this.props.translate(TLCode.MULTI_CALENDAR_ErrorMsgTooManyEconomicBlackPoints));
      }
    }
    return canEdit;
  };

  onDateSelect = async (date: Date, forcedType?: MultiCalendarSelectionType) => {
    const { selectedType, selectedDate, shiftPressed } = this.state;
    const { newDayDuties, newDayNightDuties, newNightDuties } = this.props;

    const realSelectedType =
      forcedType !== undefined
        ? forcedType
        : selectedType === MultiCalendarSelectionType.inactive
        ? MultiCalendarSelectionType.blackpointSpecial
        : selectedType;

    const dateStr = moment(date).format(dateFormatMultiCalendar);
    let dateExisting = this.checkExistingDate(dateStr);
    const canEdit = this.checkCanEdit(date, this.props.newBlackPoints, this.props.newBlackPointsEconomic);
    if (realSelectedType != null && canEdit) {
      const isDutyOffRequestDate = this.props.dutyOffRequestDates.includes(dateStr);
      if (realSelectedType == MultiCalendarSelectionType.candidates) {
        this.setState({ showCandidates: true, selectedDate: dateStr, showSelectedCandidatesDate: true });
        this.props.openCandidatesDialog(dateStr);
      } else if (
        isDutyOffRequestDate ||
        (this.props.blackPoints.includes(dateStr) &&
          (realSelectedType === MultiCalendarSelectionType.dayDuty ||
            realSelectedType === MultiCalendarSelectionType.dayNightDuty ||
            realSelectedType === MultiCalendarSelectionType.nightDuty))
      ) {
        if (
          realSelectedType === MultiCalendarSelectionType.dayDuty ||
          realSelectedType === MultiCalendarSelectionType.dayNightDuty ||
          realSelectedType === MultiCalendarSelectionType.nightDuty
        ) {
          const selectionTypeToBeDeleted = isDutyOffRequestDate
            ? MultiCalendarSelectionType.dutyOffRequest
            : MultiCalendarSelectionType.blackpoint;
          this.setState({
            isConfirmationDialogOpen: true,
            dateChangedToBeConfirm: dateStr,
            selectionTypeToBeConfirm: realSelectedType,
            selectionTypeToBeDeleted: selectionTypeToBeDeleted,
          });
        } else if (isDutyOffRequestDate) {
          NotificationToast.showInfo(this.props.translate(TLCode.MULTI_CALENDAR_InfoMsgAlreadyExempted));
        }
      } else if (realSelectedType === MultiCalendarSelectionType.delete && dateExisting) {
        this.deleteDate(dateStr);
      } else if (realSelectedType !== MultiCalendarSelectionType.delete && dateStr !== selectedDate && date != null) {
        let selectedArray;
        let deletedCorrespondingArray;
        let previousDelete;
        if (dateExisting) {
          this.deleteDate(dateStr);
        }
        switch (realSelectedType) {
          case MultiCalendarSelectionType.dutyOffRequest:
            deletedCorrespondingArray = this.props.deletedDutyOffRequests;
            break;
          case MultiCalendarSelectionType.blackpoint:
            selectedArray = this.props.newBlackPoints;
            deletedCorrespondingArray = this.props.deletedBlackPoints;
            break;
          case MultiCalendarSelectionType.blackpointEconomic:
            selectedArray = this.props.newBlackPointsEconomic;
            deletedCorrespondingArray = this.props.deletedBlackPointsEconomic;
            break;
          case MultiCalendarSelectionType.blackpointHealthy:
            selectedArray = this.props.newBlackPointsHealth;
            deletedCorrespondingArray = this.props.deletedBlackPointsHealth;
            break;
          case MultiCalendarSelectionType.blackpointSpecial:
            selectedArray = this.props.newBlackPointsSpecial;
            deletedCorrespondingArray = this.props.deletedBlackPointsSpecial;
            break;
          case MultiCalendarSelectionType.dayDuty:
            selectedArray = newDayDuties;
            deletedCorrespondingArray = this.props.deletedDayDuties;
            break;
          case MultiCalendarSelectionType.dayNightDuty:
            selectedArray = newDayNightDuties;
            deletedCorrespondingArray = this.props.deletedDayNightDuties;
            break;
          case MultiCalendarSelectionType.nightDuty:
            selectedArray = newNightDuties;
            deletedCorrespondingArray = this.props.deletedNightDuties;
            break;
        }
        if (
          shiftPressed &&
          selectedDate != null &&
          realSelectedType !== MultiCalendarSelectionType.dayDuty &&
          realSelectedType !== MultiCalendarSelectionType.dayNightDuty &&
          realSelectedType !== MultiCalendarSelectionType.nightDuty
        ) {
          selectedArray = selectedArray.filter((date) => {
            return date !== dateStr;
          });
          const dateFirst = moment(dateStr).isBefore(moment(selectedDate))
            ? moment(dateStr).startOf('day')
            : moment(selectedDate).startOf('day');
          const dateEnd = moment(dateStr).isBefore(moment(selectedDate))
            ? moment(selectedDate).endOf('day')
            : moment(dateStr).endOf('day');
          while (dateFirst.isBefore(dateEnd)) {
            const dateFirstStr = dateFirst.format(dateFormatMultiCalendar);
            dateExisting = this.checkExistingDate(dateFirstStr);
            previousDelete = deletedCorrespondingArray.includes(dateFirstStr);
            if (!dateExisting && this.checkCanEdit(dateFirst.toDate(), selectedArray, selectedArray)) {
              if (previousDelete) {
                deletedCorrespondingArray = deletedCorrespondingArray.filter((d) => d !== dateFirstStr);
              } else {
                selectedArray.push(dateFirstStr);
              }
            }
            dateFirst.add(1, 'd');
          }
          this.setState({
            selectedDate: undefined,
          });
        } else {
          previousDelete = deletedCorrespondingArray.includes(dateStr);
          if (previousDelete) {
            deletedCorrespondingArray = deletedCorrespondingArray.filter((d) => d !== dateStr);
          }
          selectedArray.push(dateStr);
          this.setState({
            selectedDate: dateStr,
          });
        }
        switch (realSelectedType) {
          case MultiCalendarSelectionType.dutyOffRequest:
            this.props.onDatesChange({
              newDutyOffRequests: selectedArray,
              deletedDutyOffRequests: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.blackpoint:
            this.props.onDatesChange({
              newBlackPoints: selectedArray,
              deletedBlackPoints: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.blackpointEconomic:
            this.props.onDatesChange({
              newBlackPointsEconomic: selectedArray,
              deletedBlackPointsEconomic: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.blackpointHealthy:
            this.props.onDatesChange({
              newBlackPointsHealth: selectedArray,
              deletedBlackPointsHealth: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.blackpointSpecial:
            this.props.onDatesChange({
              newBlackPointsSpecial: selectedArray,
              deletedBlackPointsSpecial: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.dayDuty:
            this.props.onDatesChange({
              newDayDuties: selectedArray,
              deletedDayDuties: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.dayNightDuty:
            this.props.onDatesChange({
              newDayNightDuties: selectedArray,
              deletedDayNightDuties: deletedCorrespondingArray,
            });
            break;
          case MultiCalendarSelectionType.nightDuty:
            this.props.onDatesChange({
              newNightDuties: selectedArray,
              deletedNightDuties: deletedCorrespondingArray,
            });
            break;
        }
      }
    }
  };

  dayDuty = (day) => {
    const d = this.formatDay(day);
    return this._dayDutiesSet.has(d) && !this._deletedDayDutiesSet.has(d);
  };

  nightDuty = (day) => {
    const d = this.formatDay(day);
    return this._nightDutiesSet.has(d) && !this._deletedNightDutiesSet.has(d);
  };

  dayNightDuty = (day) => {
    const d = this.formatDay(day);
    return this._dayNightDutiesSet.has(d) && !this._deletedDayNightDutiesSet.has(d);
  };

  blackPoint = (day) => {
    const d = this.formatDay(day);
    return this._blackPointsSet.has(d) && !this._deletedBlackPointsSet.has(d);
  };

  blackPointsEconomic = (day) => {
    const d = this.formatDay(day);
    return this._blackPointsEconomicSet.has(d) && !this._deletedBlackPointsEconomicSet.has(d);
  };

  blackPointsHealth = (day) => {
    const d = this.formatDay(day);
    return this._blackPointsHealthSet.has(d) && !this._deletedBlackPointsHealthSet.has(d);
  };

  blackPointsSpecial = (day) => {
    const d = this.formatDay(day);
    return this._blackPointsSpecialSet.has(d) && !this._deletedBlackPointsSpecialSet.has(d);
  };

  highlighted = (day) => {
    return day.toDateString() === new Date().toDateString(); // today
  };

  isS1 = (day) => {
    const dateDay = day.setHours(0, 0, 0, 0);
    return this.state.currentS1.beginning <= dateDay && dateDay <= this.state.currentS1.end;
  };

  isS1Weekend = (day) => {
    return IsWeekend(day) && this.isS1(day);
  };

  isS2 = (day) => {
    const dateDay = day.setHours(0, 0, 0, 0);
    return this.state.currentS2.beginning <= dateDay && dateDay <= this.state.currentS2.end;
  };

  isS2Weekend = (day) => {
    return IsWeekend(day) && this.isS2(day);
  };

  newBlackPoint = (day) => {
    return this._newBlackPointsSet.has(this.formatDay(day));
  };

  newBlackPointsEconomic = (day) => {
    return this._newBlackPointsEconomicSet.has(this.formatDay(day));
  };

  newBlackPointsHealth = (day) => {
    return this._newBlackPointsHealthSet.has(this.formatDay(day));
  };

  newBlackPointsSpecial = (day) => {
    return this._newBlackPointsSpecialSet.has(this.formatDay(day));
  };

  newDayDuty = (day) => {
    return this._newDayDutiesSet.has(this.formatDay(day));
  };

  newDayNightDuty = (day) => {
    return this._newDayNightDutiesSet.has(this.formatDay(day));
  };

  newNightDuty = (day) => {
    return this._newNightDutiesSet.has(this.formatDay(day));
  };

  bankHolidays = (day) => {
    return this._bankHolidayDatesSet.has(this.formatDay(day));
  };

  selectedCandidatesDate = (day) => {
    var selectedDate = moment(this.state.selectedDate).format(dateFormatMultiCalendar);
    return !!(this.formatDay(day) == selectedDate && this.state.showSelectedCandidatesDate);
  };

  dutyOffRequest = (day) => {
    const d = this.formatDay(day);
    return this._dutyOffRequestDatesSet.has(d) && !this._deletedExemptionsSet.has(d);
  };

  changed = (day) => {
    return this._changedDatesSet.has(this.formatDay(day));
  };

  exchangeDuty = (day) => {
    return this._exchangeDutiesSet.has(this.formatDay(day));
  };

  hasMutliDutyOrBlackPointOrDutyOffRequest = (day) => {
    return (
      [
        this.dayDuty(day),
        this.nightDuty(day),
        this.dayNightDuty(day),
        this.blackPoint(day),
        this.blackPointsEconomic(day),
        this.blackPointsHealth(day),
        this.blackPointsSpecial(day),
        this.dutyOffRequest(day),
      ].filter(Boolean).length >= 2
    );
  };

  getCountBlackPointOnBankHoliday = () => {
    return this.getBlackPointHolidayCountOnBankHoliday(this.props.newBlackPoints);
  };

  setBlackpointTypeForSemesterFrom = (date: Date) => {
    const semester = getSemester(
      moment(date)
        .add(-6, 'months')
        .toDate(),
    );
    while (date <= semester.end) {
      this.onDateSelect(date);
      date = moment(date)
        .add(1, 'day')
        .toDate();
    }
  };

  monthMap = new Map<String, String>([
    ['janv.', '01'],
    ['févr.', '02'],
    ['mars', '03'],
    ['avr.', '04'],
    ['mai', '05'],
    ['juin', '06'],
    ['juil.', '07'],
    ['août', '08'],
    ['sept.', '09'],
    ['oct.', '10'],
    ['nov.', '11'],
    ['déc.', '12'],
  ]);

  extractDateFromDayPickerDateValue = (date: String) => {
    const dateParts = date.substring(date.indexOf(' ') + 1).split(' ');
    const formattedDate = dateParts[0] + ' ' + this.monthMap.get(dateParts[1]) + ' ' + dateParts[2];
    return moment(formattedDate, 'DD MM YYYY', 'fr')
      .locale('fr')
      .toDate();
  };

  extractDutyTypeBasedOnDate = (dateStr: string): 'NIGHT' | 'DAY' | 'DAYNIGHT' | undefined => {
    if (this.props.dayNightDuties.includes(dateStr) || this.props.newDayNightDuties.includes(dateStr))
      return 'DAYNIGHT';
    if (this.props.dayDuties.includes(dateStr) || this.props.newDayDuties.includes(dateStr)) return 'DAY';
    if (this.props.nightDuties.includes(dateStr) || this.props.newNightDuties.includes(dateStr)) return 'NIGHT';
    return undefined;
  };

  contextMenuToolTypeClicked = (e: Element) => {
    //Note, the date (string) formatted from the datePicker element might change (after an upgrade), using directly a format does not work for all month.
    //Hence the string manipulation to get an easier format to handle.
    if (e.className.startsWith('DayPicker-Day')) {
      const ariaLabel = e.getAttribute('aria-label');
      if (ariaLabel !== null) {
        const date = this.extractDateFromDayPickerDateValue(ariaLabel);
        this.onDateSelect(date);
      }
    }
  };

  contextMenuInactiveClicked = (e: Element) => {
    if (e.className === 'DayPicker-Day') {
      const ariaLabel = e.getAttribute('aria-label');
      if (ariaLabel !== null) {
        var date = this.extractDateFromDayPickerDateValue(ariaLabel);
        this.setBlackpointTypeForSemesterFrom(date);
      }
    }
  };

  contextMenuSendToOtherCalendarClicked = (e: Element) => {
    if (
      !this.props.inMultiCalendar ||
      this.props.onDutyToSendToAnotherPharmacy === undefined ||
      this.props.pharmacyId === undefined
    ) {
      return;
    }
    if (e.className.startsWith('DayPicker-Day')) {
      const ariaLabel = e.getAttribute('aria-label');
      if (ariaLabel !== null) {
        const date = this.extractDateFromDayPickerDateValue(ariaLabel);
        const dateStr = moment(date).format(dateFormatMultiCalendar);
        const dutyType = this.extractDutyTypeBasedOnDate(dateStr);
        if (dutyType === undefined) return;
        if (
          this.props.otherPharmacyBusyDates !== undefined &&
          this.props.otherPharmacyBusyDates.find(
            (d) =>
              d.getDate() === date.getDate() &&
              d.getMonth() === date.getMonth() &&
              d.getFullYear() === date.getFullYear(),
          ) !== undefined
        ) {
          this.setState({ isWarningDialogOpen: true });
          return;
        }
        this.props.onDutyToSendToAnotherPharmacy(date, dutyType, this.props.pharmacyId);
        this.deleteDate(dateStr);
      }
    }
  };

  onConfirmDutyOnBpOrExemption = () => {
    const { deletedExemptions, deletedBlackPoints, newDayDuties, newNightDuties, newDayNightDuties } = this.props;

    const { dateChangedToBeConfirm, selectionTypeToBeConfirm, selectionTypeToBeDeleted } = this.state;

    if (!(dateChangedToBeConfirm && selectionTypeToBeConfirm && selectionTypeToBeDeleted)) {
      return;
    }

    const changedData: any = {};

    switch (selectionTypeToBeDeleted) {
      case MultiCalendarSelectionType.dutyOffRequest:
        deletedExemptions.push(dateChangedToBeConfirm);
        changedData.deletedExemptions = deletedExemptions;

      case MultiCalendarSelectionType.blackpoint:
        deletedBlackPoints.push(dateChangedToBeConfirm);
        changedData.deletedBlackPoints = deletedBlackPoints;
    }

    if (selectionTypeToBeConfirm === MultiCalendarSelectionType.dayDuty) {
      changedData.newDayDuties = newDayDuties;
      changedData.newDayDuties.push(dateChangedToBeConfirm);
    } else if (selectionTypeToBeConfirm === MultiCalendarSelectionType.nightDuty) {
      changedData.newNightDuties = newNightDuties;
      changedData.newNightDuties.push(dateChangedToBeConfirm);
    } else if (selectionTypeToBeConfirm === MultiCalendarSelectionType.dayNightDuty) {
      changedData.newDayNightDuties = newDayNightDuties;
      changedData.newDayNightDuties.push(dateChangedToBeConfirm);
    }
    this.props.onDatesChange(changedData);

    this.setState({
      isConfirmationDialogOpen: false,
      dateChangedToBeConfirm: undefined,
      selectionTypeToBeConfirm: undefined,
      selectionTypeToBeDeleted: undefined,
    });
  };

  getCalendarContextToolboxProps = (): Omit<CalendarContextToolboxProps, 'children'> => {
    return {
      bpCount: this.getCountBlackPointOnBankHoliday(),
      bpMax: this.props.blackPointHolidayMax === undefined ? 0 : this.props.blackPointHolidayMax,
      isSecretariat: this.props.isSecretariat === undefined ? false : this.props.isSecretariat,
      onTypeClicked: (contextMenu2ContentProps: ContextMenu2ContentProps) => (type: MultiCalendarSelectionType) => {
        this.setState({ isContextualMenuDisabled: true });
        this.setState({
          nextActionAfterContextMenu: () => {
            simulateClickOn(
              contextMenu2ContentProps.targetOffset!.left,
              contextMenu2ContentProps.targetOffset!.top,
              type === MultiCalendarSelectionType.inactive
                ? this.contextMenuInactiveClicked
                : this.contextMenuToolTypeClicked,
            );
          },
        });
        this.onTypeChange(type);
      },
      onClose: () => {
        this.setState({ isContextualMenuDisabled: true });
      },
      selectedType: this.state.selectedType,
      translate: this.props.translate,
      onTransfertDuty: this.props.inMultiCalendar
        ? (contextMenu2ContentProps: ContextMenu2ContentProps) => () => {
            this.setState({ isContextualMenuDisabled: true });
            this.setState({
              nextActionAfterContextMenu: () => {
                simulateClickOn(
                  contextMenu2ContentProps.targetOffset!.left,
                  contextMenu2ContentProps.targetOffset!.top,
                  this.contextMenuSendToOtherCalendarClicked,
                );
              },
            });
          }
        : undefined,
      disabled: this.state.isContextualMenuDisabled,
    } as Omit<CalendarContextToolboxProps, 'children'>;
  };

  getMinMaxDatesSixMonths = (year, initialMonth) => {
    const minDate = new Date(year, initialMonth, 1);
    let maxDate;
    for (let i = initialMonth; i < initialMonth + 6; i++) {
      maxDate = i === 11 ? new Date(year + 1, 0) : new Date(year, i + 1);
      maxDate.setDate(maxDate.getDate() - 1);
    }

    const minDt = moment(minDate, 'YYYY-MM-DD');
    const maxDt = moment(maxDate, 'YYYY-MM-DD');

    return { minDt, maxDt };
  };

  getNumberOfDuties = (duties: string[], minDt: Moment, maxDt: Moment) => {
    if (duties.length === 0) return 0;
    return duties.filter((elem) => {
      return moment(elem, 'YYYY-MM-DD').isSameOrAfter(minDt) && moment(elem, 'YYYY-MM-DD').isSameOrBefore(maxDt);
    })!.length;
  };

  getDutiesCountFrom = (duties: string[], semester: Semester) => {
    const minDt = moment(semester.beginning);
    const maxDt = moment(semester.end);
    return this.getNumberOfDuties(duties, minDt, maxDt);
  };

  getDayDutiesCount = (ofSemester: Semester): number => this.getDutiesCountFrom(this.props.dayDuties, ofSemester);

  getDayNightDutiesCount = (ofSemester: Semester): number =>
    this.getDutiesCountFrom(this.props.dayNightDuties, ofSemester);

  getNightDutiesCount = (ofSemester: Semester): number => this.getDutiesCountFrom(this.props.nightDuties, ofSemester);

  getSaturdayDutiesCount = (ofSemester: Semester): number =>
    this.getDutiesCountFrom(this.props.saturdayDuties, ofSemester);

  getSundayDutiesCount = (ofSemester: Semester): number => this.getDutiesCountFrom(this.props.sundayDuties, ofSemester);

  getBHDutiesCount = (ofSemester: Semester): number => this.getDutiesCountFrom(this.props.BHDuties, ofSemester);

  onScroll = (e) => {
    if (this.props.synchronizedScrolling) {
      $('.scrollingCalendar').each(function(index, element: any) {
        if (element !== e.target) {
          const $element: any = $(element);
          const $target: any = $(e.target);
          $element.scrollTop($target.scrollTop());
          $element.scrollLeft($target.scrollLeft());
          sessionStorage.setItem('scrollingCalendarScrollPositionTop', $target.scrollTop());
          sessionStorage.setItem('scrollingCalendarScrollPositionLeft', $target.scrollLeft());
        }
      });
    }
  };

  navigate = (direction: 'UP' | 'DOWN') => {
    let { firstMonthFirstLine, firstMonthSecondLine, yearFirstLine, yearSecondLine } = this.state;
    const { navigateMonthCount } = this.props;

    if (direction === 'DOWN') {
      firstMonthFirstLine += navigateMonthCount;
      firstMonthSecondLine += navigateMonthCount;
      if (firstMonthFirstLine > 11) {
        firstMonthFirstLine -= 12;
        yearFirstLine++;
      }
      if (firstMonthSecondLine > 11) {
        firstMonthSecondLine -= 12;
        yearSecondLine++;
      }
    } else if (direction === 'UP') {
      firstMonthFirstLine -= navigateMonthCount;
      firstMonthSecondLine -= navigateMonthCount;
      if (firstMonthFirstLine < 0) {
        firstMonthFirstLine += 12;
        yearFirstLine--;
      }
      if (firstMonthSecondLine < 0) {
        firstMonthSecondLine += 12;
        yearSecondLine--;
      }
    }

    this.setState({
      firstMonthFirstLine,
      firstMonthSecondLine,
      yearFirstLine,
      yearSecondLine,
      currentS1: getS1(yearFirstLine),
      currentS2: getS2(yearFirstLine),
    });
    this.props.onCalendarMove(yearFirstLine, yearSecondLine);
  };

  translatePrefDayOff = (dayOff) => {
    if (dayOff == undefined) return TLCode.NA;
    const weekdays = {
      MONDAY: TLCode.Monday,
      TUESDAY: TLCode.Tuesday,
      WEDNESDAY: TLCode.Wednesday,
      THURSDAY: TLCode.Thursday,
      FRIDAY: TLCode.Friday,
      SATURDAY: TLCode.Saturday,
      SUNDAY: TLCode.Sunday,
    };
    return weekdays[dayOff];
  };

  closeWarningDialog = () => {
    this.setState({ isWarningDialogOpen: false });
  };

  closeConfirmationDialog = () => {
    this.setState({ isConfirmationDialogOpen: false });
  };

  selectPharmacy(pharmacyDetail: Instance<typeof PharmacyDetails>) {
    this.setState({ selectedPharmacy: pharmacyDetail });

    var pharmacy = this.props.pharmacyList.find((x) => x.apbNumber === pharmacyDetail.apbNumber);
    this.props.onOtherPharmacyChange!(pharmacy.pharmacyId);
  }

  private goToStartOfCalendars = () => {
    var htmlElements: Element[] = Array.from(document.getElementsByClassName('scrollingCalendar'));
    htmlElements.forEach((element) => {
      var elementPosition = element.parentElement!.getBoundingClientRect();
      element.scroll(0, elementPosition.y);
    });
  };

  private goToEndOfCalendars = () => {
    var htmlElements: Element[] = Array.from(document.getElementsByClassName('scrollingCalendar'));
    htmlElements.forEach((element) => {
      var elementPosition = element.parentElement!.getBoundingClientRect();
      element.scroll(elementPosition.right, elementPosition.y);
    });
  };

  private getGroupName = (pharmacy: Instance<typeof Pharmacy>) =>
    pharmacy.groupId !== undefined && pharmacy.groupId > 0
      ? this.props.groupList.find((g) => g.groupId === pharmacy.groupId)!.name
      : '';

  private getCalendarModifiers = () => ({
    bankHolidays: this.bankHolidays,
    dayDuty: this.dayDuty,
    nightDuty: this.nightDuty,
    dayNightDuty: this.dayNightDuty,
    blackPoint: this.blackPoint,
    blackPointsEconomic: this.blackPointsEconomic,
    blackPointsHealth: this.blackPointsHealth,
    blackPointsSpecial: this.blackPointsSpecial,
    dutyOffRequest: this.dutyOffRequest,
    highlighted: this.highlighted,
    newBlackPoint: this.newBlackPoint,
    newBlackPointsEconomic: this.newBlackPointsEconomic,
    newBlackPointsHealth: this.newBlackPointsHealth,
    newBlackPointsSpecial: this.newBlackPointsSpecial,
    newDayDuty: this.newDayDuty,
    newDayNightDuty: this.newDayNightDuty,
    newNightDuty: this.newNightDuty,
    changed: this.changed,
    weekends: IsWeekend,
    s1weekends: this.isS1Weekend,
    s1: this.isS1,
    s2weekends: this.isS2Weekend,
    s2: this.isS2,
    conflict: this.hasMutliDutyOrBlackPointOrDutyOffRequest,
    candidates: this.selectedCandidatesDate,
    exchangeDuty: this.exchangeDuty,
  });

  private handleDateChange = (date: Date) => {
    if (this.state.selectedType !== MultiCalendarSelectionType.inactive) this.onDateSelect(date);
    else this.setBlackpointTypeForSemesterFrom(date);
  };

  private getS1DutyCounters = () => {
    const counters = {
      semesterNumber: 1,
      dayDutiesCount: this.getDayDutiesCount(this.state.currentS1),
      dayNightDutiesCount: this.getDayNightDutiesCount(this.state.currentS1),
      nightDutiesCount: this.getNightDutiesCount(this.state.currentS1),
      saturdayDutiesCount: this.getSaturdayDutiesCount(this.state.currentS1),
      sundayDutiesCount: this.getSundayDutiesCount(this.state.currentS1),
      BHDutiesCount: this.getBHDutiesCount(this.state.currentS1),
    } as SemesterDutyCountersProps;

    return counters;
  };

  private getS2DutyCounters = () => {
    return {
      semesterNumber: 1,
      dayDutiesCount: this.getDayDutiesCount(this.state.currentS2),
      dayNightDutiesCount: this.getDayNightDutiesCount(this.state.currentS2),
      nightDutiesCount: this.getNightDutiesCount(this.state.currentS2),
      saturdayDutiesCount: this.getSaturdayDutiesCount(this.state.currentS2),
      sundayDutiesCount: this.getSundayDutiesCount(this.state.currentS2),
      BHDutiesCount: this.getBHDutiesCount(this.state.currentS2),
    } as SemesterDutyCountersProps;
  };

  render() {
    // ── Perf monitoring ──────────────────────────────────────────────────────
    // reset() lives in PharmacyDutiesCalendar.render() — it is the outermost
    // render so its measurements survive into the final report.
    this._perfRenderStart = performance.now();
    // ─────────────────────────────────────────────────────────────────────────

    // Invalidate the formatDay cache so stale Date references from a previous render don't hit.
    this._lastFormattedDay = null;

    // Rebuild Sets from current props — O(N) once per render instead of O(N) per day-cell per modifier.
    CalendarPerfMonitor.measure('[MC] rebuildSets', () => {
      const p = this.props;
      this._bankHolidayDatesSet = new Set(p.bankHolidayDates);
      this._dayDutiesSet = new Set(p.dayDuties);
      this._nightDutiesSet = new Set(p.nightDuties);
      this._dayNightDutiesSet = new Set(p.dayNightDuties);
      this._blackPointsSet = new Set(p.blackPoints);
      this._blackPointsEconomicSet = new Set(p.blackPointsEconomic);
      this._blackPointsHealthSet = new Set(p.blackPointsHealth);
      this._blackPointsSpecialSet = new Set(p.blackPointsSpecial);
      this._deletedDayDutiesSet = new Set(p.deletedDayDuties);
      this._deletedNightDutiesSet = new Set(p.deletedNightDuties);
      this._deletedDayNightDutiesSet = new Set(p.deletedDayNightDuties);
      this._deletedBlackPointsSet = new Set(p.deletedBlackPoints);
      this._deletedBlackPointsEconomicSet = new Set(p.deletedBlackPointsEconomic);
      this._deletedBlackPointsHealthSet = new Set(p.deletedBlackPointsHealth);
      this._deletedBlackPointsSpecialSet = new Set(p.deletedBlackPointsSpecial);
      this._deletedExemptionsSet = new Set(p.deletedExemptions);
      this._dutyOffRequestDatesSet = new Set(p.dutyOffRequestDates);
      this._newBlackPointsSet = new Set(p.newBlackPoints);
      this._newBlackPointsEconomicSet = new Set(p.newBlackPointsEconomic);
      this._newBlackPointsHealthSet = new Set(p.newBlackPointsHealth);
      this._newBlackPointsSpecialSet = new Set(p.newBlackPointsSpecial);
      this._newDayDutiesSet = new Set(p.newDayDuties);
      this._newDayNightDutiesSet = new Set(p.newDayNightDuties);
      this._newNightDutiesSet = new Set(p.newNightDuties);
      this._changedDatesSet = new Set([
        ...p.newBlackPoints,
        ...p.newBlackPointsEconomic,
        ...p.newBlackPointsHealth,
        ...p.newBlackPointsSpecial,
        ...p.newDayDuties,
        ...p.newNightDuties,
        ...p.newDayNightDuties,
        ...p.deletedDutyOffRequests,
        ...p.deletedBlackPoints,
        ...p.deletedBlackPointsHealth,
        ...p.deletedBlackPointsEconomic,
        ...p.deletedBlackPointsSpecial,
        ...p.deletedDayDuties,
        ...p.deletedNightDuties,
        ...p.deletedDayNightDuties,
      ]);
      this._exchangeDutiesSet = new Set(p.exchangeDutyDates || []);
    });
    const {
      firstMonthFirstLine,
      firstMonthSecondLine,
      yearFirstLine,
      yearSecondLine,
      isConfirmationDialogOpen,
      showCandidates,
    } = this.state;
    const { translate } = this.props;
    const { isSecretariat } = this.props;

    const countBlackPointHoliday = CalendarPerfMonitor.measure('getBlackPointHolidayCount', () =>
      this.getBlackPointHolidayCount(this.props.newBlackPoints),
    );
    const countBlackPointEconomic = CalendarPerfMonitor.measure('getBlackPointEconomicCount', () =>
      this.getBlackPointEconomicCount(this.props.newBlackPointsEconomic),
    );
    const countBlackPointOnBankHoliday = CalendarPerfMonitor.measure('getBlackPointHolidayCountOnBankHoliday', () =>
      this.getBlackPointHolidayCountOnBankHoliday(this.props.newBlackPoints),
    );
    const countBlackPointOnWeekend = CalendarPerfMonitor.measure('getBlackPointHolidayCountOnWeekends', () =>
      this.getBlackPointHolidayCountOnWeekends(this.props.newBlackPoints),
    );
    // Pre-compute inline JSX calls so they can be individually timed
    const s1DutyCounters = CalendarPerfMonitor.measure('getS1DutyCounters', () => this.getS1DutyCounters());
    const s2DutyCounters = CalendarPerfMonitor.measure('getS2DutyCounters', () => this.getS2DutyCounters());
    const calendarContextToolboxProps = CalendarPerfMonitor.measure('getCalendarContextToolboxProps', () =>
      this.getCalendarContextToolboxProps(),
    );
    const hasDutyNextYearVal = CalendarPerfMonitor.measure('hasDutyNextYear', () => this.hasDutyNextYear());
    // ─────────────────────────────────────────────────────────────────────────

    const firstDate = this.props.systemStatus
      ? this.props.systemStatus.find((elem) => elem.subSystem === 'NextAcceptableBlackpoint')
        ? moment(
            this.props.systemStatus.find((elem) => elem.subSystem === 'NextAcceptableBlackpoint')!.status,
            'DD/MM/YYYY',
          ).format('DD/MM/YYYY')
        : ''
      : '';

    return (
      <>
        <ConfirmationDialog
          isOpen={isConfirmationDialogOpen}
          onContinue={this.onConfirmDutyOnBpOrExemption}
          title={translate(TLCode.CALENDAR_Confirmation_BP_Exemption_Duty_Title)}
          message={translate(TLCode.CALENDAR_Confirmation_BP_Exemption_Duty_Text)}
          confirmText={translate(TLCode.PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Confirm)}
          cancelText={translate(TLCode.PHARMACY_DUTY_CALENDAR_ConfirmationDialog_Cancel)}
          onCancel={this.closeConfirmationDialog}
        />
        <WarningDialog
          isOpen={this.state.isWarningDialogOpen}
          close={this.closeWarningDialog}
          dialogLabels={{
            title: translate(TLCode.MULTI_CALENDAR_Transfert_Warning_Title),
            content: translate(TLCode.MULTI_CALENDAR_Transfert_Warning_Content),
            validateButton: translate(TLCode.Close),
          }}
        />
        <span>
          {this.props.separateToolbox && (
            <ToolboxAndLegend
              blackPointHolidayCount={countBlackPointHoliday}
              blackPointHolidayMax={this.props.blackPointHolidayMax}
              isSecretariat={isSecretariat}
              navigate={this.navigate}
              fly={yearFirstLine}
              firstBPEncodingDate={firstDate}
              onTypeChange={this.onTypeChange}
              selectedType={this.state.selectedType}
              onS1Clicked={this.props.inMultiCalendar ? this.goToStartOfCalendars : undefined}
              onS2Clicked={this.props.inMultiCalendar ? this.goToEndOfCalendars : undefined}
              translate={translate}
            />
          )}
          <HorizontalContainer>
            {this.props.pharmacyList && this.props.inMultiCalendar && (
              <>
                <LazyPharmacySelectionForCalendar
                  pharmacyId={this.props.pharmacyId}
                  onPharmacyChange={this.props.onPharmacyChange}
                  pharmacyList={this.props.pharmacyList.filter(
                    (pharmacy) =>
                      this.props.groupIdToLimitTo === undefined ||
                      !this.state.limitSelectionToGroupOfFirstPickedPharmacy ||
                      pharmacy.groupId === this.props.groupIdToLimitTo,
                  )}
                  getGroupName={this.getGroupName}
                  lazy={!this.props.groupIdToLimitTo || !this.state.limitSelectionToGroupOfFirstPickedPharmacy}
                />
                {this.props.groupIdToLimitTo && (
                  <CheckBox
                    text={translate(TLCode.MULTI_CALENDAR_LimitSelectionToGroupOfFirstPickedPharmacy)}
                    disabled={false}
                    value={this.state.limitSelectionToGroupOfFirstPickedPharmacy}
                    onValueChange={(value) => {
                      if (value !== null) this.setState({ limitSelectionToGroupOfFirstPickedPharmacy: value });
                    }}
                  />
                )}
              </>
            )}
            {this.props.pharmacyDetails && (
              <PharmacyPreferenceNoDutyDayForCalendar
                pharmacyDetails={this.props.pharmacyDetails}
                getGroupName={this.getGroupName}
                getPrefDayDutyText={(pharmacyDetails) =>
                  isSecretariat
                    ? translate(TLCode.PHARMACY_PrefDayOff) +
                      ' ' +
                      translate(this.translatePrefDayOff(pharmacyDetails.prefDutyDayOff))
                    : ''
                }
                showDetails={!this.props.inMultiCalendar}
                emailAddress={this.props.pharmacyUser !== undefined ? this.props.pharmacyUser!.email : undefined}
              />
            )}
          </HorizontalContainer>
          <VerticalContainer onKeyDown={this.handleKeyPress} onKeyUp={this.handleKeyUnPress}>
            {!this.props.inMultiCalendar &&
              this.props.sharedDutiesGroupPharmacies !== undefined &&
              this.props.sharedDutiesGroupPharmacies.length > 0 &&
              this.props.navigateTo && (
                <HorizontalContainer>
                  <SharedDutiesGroupInformation
                    allPharmaciesInGroup={this.props.sharedDutiesGroupPharmacies}
                    translate={this.props.translate}
                    navigate={this.props.navigateTo}
                  />
                </HorizontalContainer>
              )}
            <HorizontalContainer>
              <CalendarCounters
                blackPointHolidayCount={countBlackPointHoliday}
                blackPointEconomicCount={countBlackPointEconomic}
                blackPointHolidayMax={this.props.blackPointHolidayMax ? this.props.blackPointHolidayMax : 0}
                blackPointEconomicMax={this.props.blackPointEconomicMax ? this.props.blackPointEconomicMax : 0}
                annualFreeBankHolidayMax={this.props.annualFreeBankHolidayMax ? this.props.annualFreeBankHolidayMax : 0}
                blackPointOnBankHolidayCount={countBlackPointOnBankHoliday}
                annualFreeWeekendMax={this.props.annualFreeWeekendMax ? this.props.annualFreeWeekendMax : 0}
                blackPointOnWeekendCount={countBlackPointOnWeekend}
                showEconomicCounters={isSecretariat || false}
                semester1DutyCounters={s1DutyCounters}
                semester2DutyCounters={s2DutyCounters}
              />
            </HorizontalContainer>
            <HorizontalContainer>
              <ContainerCalendars>
                <CalendarContextToolbox {...calendarContextToolboxProps}>
                  {this.props.rowCount === undefined || this.props.rowCount === 2 ? (
                    <TwoLinesPharmacyCalendarDatePicker
                      year={yearFirstLine}
                      initialMonth={firstMonthFirstLine}
                      yearSecondLine={yearSecondLine}
                      initialMonthSecondLine={firstMonthSecondLine}
                      modifiers={this.getCalendarModifiers()}
                      onChange={this.handleDateChange}
                    />
                  ) : this.props.rowCount === 1 ? (
                    <>
                      <OneLinePharmacyCalendarDatePicker
                        year={yearFirstLine}
                        initialMonth={firstMonthFirstLine}
                        onScroll={this.onScroll}
                        modifiers={this.getCalendarModifiers()}
                        onChange={this.handleDateChange}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </CalendarContextToolbox>
              </ContainerCalendars>
              {!this.props.hideLegend && (
                <DivVerticallyCenter>
                  <NavigateContainer>
                    <Tooltip
                      content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_PreviousYear)}
                      position={Position.BOTTOM}
                      hoverOpenDelay={750}
                    >
                      <Button
                        icon={IconNames.CHEVRON_UP}
                        large={true}
                        style={{ height: '30px', marginLeft: '5px' }}
                        onClick={() => this.navigate('UP')}
                      />
                    </Tooltip>
                    <Tooltip
                      content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_NextYear)}
                      position={Position.BOTTOM}
                      hoverOpenDelay={750}
                    >
                      <Button
                        icon={IconNames.CHEVRON_DOWN}
                        large={true}
                        style={{ height: '30px', marginLeft: '5px' }}
                        onClick={() => this.navigate('DOWN')}
                        intent={hasDutyNextYearVal ? Intent.DANGER : Intent.NONE}
                        className={hasDutyNextYearVal ? flashingButton : ''}
                      />
                    </Tooltip>
                  </NavigateContainer>
                </DivVerticallyCenter>
              )}
            </HorizontalContainer>
          </VerticalContainer>
        </span>
      </>
    );
  }
}

export default withTranslate(MultiCalendar);

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
`;

const ContainerCalendars = styled.div`
  display: flex;
  flex-direction: column;
  & .bp3-datepicker {
    padding: 0px;
  }
  & .DayPicker-Day.DayPicker-Day--conflict {
    border-color: #0080ff;
    border-width: 2px;
    border-style: solid;
  }
  & .DayPicker-Day.DayPicker-Day--selected {
    background-color: white;
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--dayDuty {
    background-image: url(${dutyDay});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--nightDuty {
    background-image: url(${dutyNight});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--dayNightDuty {
    background-image: url(${dutyDayNight});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--blackPoint {
    background-image: url(${blackpoint});
    color: white;
  }
  & .DayPicker-Day.DayPicker-Day--blackPointsHealth {
    background-image: url(${blackpointHealthy});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--blackPointsSpecial {
    background-image: url(${blackpointSpecial});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--blackPointsEconomic {
    background-image: url(${blackpointEconomic});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--newBlackPoint {
    background-image: url(${blackpoint});
    color: white;
  }
  & .DayPicker-Day.DayPicker-Day--newBlackPointsHealth {
    background-image: url(${blackpointHealthy});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--newBlackPointsSpecial {
    background-image: url(${blackpointSpecial});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--newBlackPointsEconomic {
    background-image: url(${blackpointEconomic});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--newDayDuty {
    background-image: url(${dutyDay});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--newDayNightDuty {
    background-image: url(${dutyDayNight});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--newNightDuty {
    background-image: url(${dutyNight});
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--dutyOffRequest {
    background-image: url(${dutyOff});
  }
  & .DayPicker-Day.DayPicker-Day--bankHolidays {
    color: #b52d4f;
    font-weight: bold;
  }
  & .DayPicker-Day.DayPicker-Day--weekends {
    background-color: #f4f4f4;
  }
  & .DayPicker-Day.DayPicker-Day--s1 {
    background-color: #dbfcfb;
  }
  & .DayPicker-Day.DayPicker-Day--s1weekends {
    background-color: #b4eae8;
  }
  & .DayPicker-Day.DayPicker-Day--s2 {
    background-color: #fcecd9;
  }
  & .DayPicker-Day.DayPicker-Day--s2weekends {
    background-color: #edddc9;
  }
  & .DayPicker-Day.DayPicker-Day--changed {
    border-color: red;
    border-width: 2px;
    border-style: solid;
  }
  & .DayPicker-Day.DayPicker-Day--highlighted {
    background-color: #669eff;
    font-weight: bold;
    color: black;
  }
  & .DayPicker-Day.DayPicker-Day--candidates {
    font-weight: bold;
    color: black;
    border-color: #e724f2;
    border-width: 2px;
    border-style: solid;
  }
  & .DayPicker-Day.DayPicker-Day--outside {
    background-color: white;
    opacity: 0;
  }
  & .DayPicker-Day.DayPicker-Day--exchangeDuty {
    position: relative;
  }
  & .DayPicker-Day.DayPicker-Day--exchangeDuty::before {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 11px;
    height: 11px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10' fill='none'%3E%3Cpath d='M1 3h7' stroke='%23ff00ff' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M6 1l2 2-2 2' stroke='%23ff00ff' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M9 7H2' stroke='%23ff00ff' stroke-width='1.5' stroke-linecap='round'/%3E%3Cpath d='M4 5l-2 2 2 2' stroke='%23ff00ff' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    pointer-events: none;
    z-index: 1;
  }
  & .DayPicker-NavButton {
    display: none;
  }
`;

const DivVerticallyCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
